<template>
    <div>
        <v-text-field
            v-model="inputField"
            :data-id="`input-item-${item.name}`"
            :label="item.label"
            :type="inputType"
            variant="outlined"
            :min="isNumberInput ? 0 : null"
            :class="cssClass"
            @input="handleInput"
            @keypress="checkKey"
        />
    </div>
</template>

<script lang="ts" setup>
import { DriverMessageInputType, MessageInputTemplate } from '@/features/messages/MessageTemplate';
import { computed, ref } from 'vue';

const props = defineProps<{
    item: MessageInputTemplate;
}>();

const emit = defineEmits(['input']);
const inputField = ref(null);
const isNumberInput = computed(() => {
    return props.item.inputType === DriverMessageInputType.Number;
});

const inputType = computed(() => {
    if (props.item.inputType === DriverMessageInputType.Number) {
        return 'number';
    }

    return 'text';
});

const cssClass = computed(() => {
    if (props.item.inputType === DriverMessageInputType.Number) {
        return 'number';
    }

    return '';
});

function checkKey(e) {
    if (!isNumberInput.value) return;
    if (e.charCode === 43 || e.charCode === 45 || e.charCode === 46 || e.charCode === 101) {
        e.preventDefault();
    }
}

const handleInput = () => {
    emit('input', { name: props.item.name, value: inputField.value });
};
</script>

<style scoped lang="scss">
.number {
    width: 204px;
}
</style>
